import { Onboarding, TooltipProvider } from '@statsbomb/kitbag-components';
import { useFirstTimeDismissal } from '@/hooks/useFirstTimeDismissal';
import { OnboardingItemKey } from '@/types/userConfigs';

export type OnboardingTooltipProps = Pick<
  React.ComponentProps<typeof Onboarding>,
  'header' | 'content' | 'children' | 'position'
> & {
  itemKey: OnboardingItemKey;
};

export const OnboardingTooltip = ({
  itemKey,
  header,
  content,
  children,
  position = 'bottom',
}: OnboardingTooltipProps) => {
  const { isOpen, dismiss } = useFirstTimeDismissal(itemKey);

  return (
    <TooltipProvider>
      <Onboarding
        isOpen={isOpen}
        header={header}
        content={content}
        position={position}
        onOpenChange={open => {
          if (!open) dismiss();
        }}
      >
        {children}
      </Onboarding>
    </TooltipProvider>
  );
};
